import React from "react";
import SectionHeading from "@/components/site/SectionHeading";
import ServiceCard from "@/components/site/ServiceCard";
import { SERVICES } from "@/data/site";

export default function ServicesPreview() {
  return (
    <section id="services" className="bg-onyx pt-3 pb-6 sm:py-16 md:py-24" aria-labelledby="services-heading">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="reveal">
          <SectionHeading id="services-heading" dark>Our Services</SectionHeading>
          <div className="mt-3 flex justify-center" aria-hidden="true">
            <svg width="72" height="12" viewBox="0 0 72 12" className="text-gold/70" fill="none" stroke="currentColor">
              <path d="M2 6 H 29" strokeWidth="1" />
              <path d="M43 6 H 70" strokeWidth="1" />
              <path d="M36 2 l4 4 -4 4 -4 -4 z" fill="currentColor" stroke="none" />
            </svg>
          </div>
        </div>
        <div className="mt-6 grid grid-cols-3 gap-2.5 sm:mt-8 sm:gap-5 md:gap-7">
          {SERVICES.map((s) => (
            <div key={s.slug} className="reveal h-full">
              <ServiceCard service={s} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
